import PropTypes from 'prop-types';
import React from 'react';

import { Div, P } from 'common/styles/oc-styled-components';
import { colors } from 'common/styles/style-constants';
import {
  DIMENSIONS,
  useWindowDimensions,
} from 'providers/WindowDimensionsProvider';

import Timeline1 from '../../../common/components/svgs/rewards-timeline/timeline_1.png';
import Timeline2 from '../../../common/components/svgs/rewards-timeline/timeline_2.png';
import Timeline3 from '../../../common/components/svgs/rewards-timeline/timeline_3.png';
import Timeline4 from '../../../common/components/svgs/rewards-timeline/timeline_4.png';
import { OFFER_TERMS_URL } from '../../../common/constants/search-constants';

import {
  Checkmark,
  H1,
  H2,
  Img,
  Inline,
  Link,
  StyledModal,
  Timeline,
  TimelineCopy,
  TimelineItem,
  UL,
} from './styled-components';

const OpencareRewardsModal = ({
  opencareRewardsModalVisible,
  setOpencareRewardsModalVisible,
  isThirdPartyOffer,
  offerName,
}) => {
  const { layout } = useWindowDimensions();

  return (
    <StyledModal
      centered
      footer={null}
      onCancel={e => {
        e.preventDefault();
        setOpencareRewardsModalVisible(false);
      }}
      visible={opencareRewardsModalVisible}
      width={layout === DIMENSIONS.MOBILE ? '100vw' : '840px'}
    >
      <Div
        padding={layout !== DIMENSIONS.MOBILE ? '40px 50px' : '20px 30px'}
        data-testid="offer-modal"
      >
        <H1
          color={colors.darkBlue}
          fontSize={layout !== DIMENSIONS.MOBILE ? '28px' : '25px'}
          margin="0 0 5px"
        >
          Smile More. <Inline>Get More.</Inline>
        </H1>

        <Timeline>
          <TimelineItem>
            <Img src={Timeline1} role="presentation" alt="" />
            <TimelineCopy>Book a new dentist with Opencare</TimelineCopy>
          </TimelineItem>
          {!isThirdPartyOffer 
            && (
              <>
                <TimelineItem>
                  <Img src={Timeline2} role="presentation" alt="" />
                  <TimelineCopy>Visit your new Opencare dentist</TimelineCopy>
                </TimelineItem>
                <TimelineItem>
                  <Img src={Timeline3} role="presentation" alt="" />
                  <TimelineCopy>Submit your receipt to opencare.com</TimelineCopy>
                </TimelineItem>
              </>
            )
          }
          <TimelineItem>
            <Img src={Timeline4} role="presentation" alt="" />
            <TimelineCopy>
              {isThirdPartyOffer
                ? offerName
                : `You get a ${offerName} by email`}
            </TimelineCopy>
          </TimelineItem>
        </Timeline>

        <H2>Am I eligible?</H2>

        <UL>
          <li>
            <Checkmark />
            <span>
              You complete a new patient exam and another dental service, such
              as a cleaning. Dental consultations, including x-rays, do not
              qualify for rewards.
            </span>
          </li>
          <li>
            <Checkmark />
            You are at least 18 years old on the date of your appointment.
          </li>
          <li>
            <Checkmark />
            You have not claimed an Opencare reward in the past 2 years.
          </li>
          <li>
            <Checkmark />
            You are not an existing patient of the dental practice.
          </li>
          <li>
            <Checkmark />
            You are not using government funded insurance (e.g., Medicaid,
            Medicare, provincial health plans in Canada, or the Canada Dental
            Care Plan)
          </li>
          <li>
            <Checkmark />
            Your appointment was booked using the name on your Opencare account.
            If one account was used to book appointments or two or more
            patients, only one patient will be able to claim a reward.
          </li>
        </UL>

        <P
          fontSize={layout !== DIMENSIONS.MOBILE ? '13px' : '10px'}
          textAlign="center"
        >
          For more information, visit{' '}
          <Link href={OFFER_TERMS_URL} target="_blank">
            www.opencare.com/terms/offers
          </Link>{' '}
          or contact{' '}
          <Link href="mailto:support@opencare.com" target="_blank">
            support@opencare.com
          </Link>
        </P>
      </Div>
    </StyledModal>
  );
};

OpencareRewardsModal.propTypes = {
  opencareRewardsModalVisible: PropTypes.bool,
  setOpencareRewardsModalVisible: PropTypes.func,
  offerName: PropTypes.string,
  isThirdPartyOffer: PropTypes.bool,
};

export default OpencareRewardsModal;
